import $ from "jquery";

function disableAssetForm() {
  $("#fieldset").attr("disabled", true)
  $("input[type='submit']").attr("disabled", false)
  $(".field-group.-heavy").addClass("disabled")
}

function enableAssetForm() {
  $("input, textarea, select", "#edit-asset-form").attr("disabled", false)
  $(".field-group.-heavy").removeClass("disabled")
  $("#fieldset").attr("disabled", false)
}

function rad(x) {
  return x * Math.PI / 180
}

function getDistanceInMeters(lat1, lng1, lat2, lng2) {
  var R = 6378137
  var dLat = rad(lat2 - lat1)
  var dLong = rad(lng2 - lng1)
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(lat1)) * Math.cos(rad(lat2)) * Math.sin(dLong / 2) * Math.sin(dLong / 2)
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  var d = R * c
  return d
}

function calculateRange() {
  if (window.isAdmin) {
    $("#begin_assessment").removeClass("disabled").addClass("in_range").html("Begin (Admin)")
  } else if (window.isNewRecord) {
    $("#begin_assessment").removeClass("disabled").addClass("in_range").html("Begin (New Asset)")
  } else if (navigator.geolocation) {
    $("#begin_assessment").html("You must be within 200' to begin<br />Detecting distance...").removeClass("out_of_range")
    navigator.geolocation.getCurrentPosition(function(position){
      var pinLat = $("#asset_latitude").val()
      if(pinLat == "") {
        pinLat = $map.getCenter()[0]
      }

      var pinLng = $("#asset_longitude").val()
      if(pinLng == "") {
        pinLng = $map.getCenter()[1]
      }

      const distance = getDistanceInMeters(pinLat, pinLng, position.coords.latitude, position.coords.longitude)

      if (distance < 61) {
        $("#begin_assessment").removeClass("disabled").addClass("in_range").html("Begin Assessment")
      } else {
        $("#begin_assessment").removeClass("disabled").addClass("out_of_range").html("You must be within 200' to begin assessment<br />You are out of range<br />Click here to re-check your range")
      }
    }, function(){
      $("#begin_assessment").html("Location data is unavailable")
    })
  } else {
    $("#begin_assessment").html("Location data is unavailable")
  }
}

window.disableAssetForm = disableAssetForm;
window.enableAssetForm = enableAssetForm;
window.calculateRange = calculateRange;
